var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle",
    d: "M4.73 8.03L8.6075 4.1525L7.8375 3.3825L4.73 6.49L3.1625 4.9225L2.3925 5.6925L4.73 8.03ZM5.5 11C4.73917 11 4.02417 10.8556 3.355 10.5669C2.68583 10.2781 2.10375 9.88625 1.60875 9.39125C1.11375 8.89625 0.721875 8.31417 0.433125 7.645C0.144375 6.97583 0 6.26083 0 5.5C0 4.73917 0.144375 4.02417 0.433125 3.355C0.721875 2.68583 1.11375 2.10375 1.60875 1.60875C2.10375 1.11375 2.68583 0.721875 3.355 0.433125C4.02417 0.144375 4.73917 0 5.5 0C6.26083 0 6.97583 0.144375 7.645 0.433125C8.31417 0.721875 8.89625 1.11375 9.39125 1.60875C9.88625 2.10375 10.2781 2.68583 10.5669 3.355C10.8556 4.02417 11 4.73917 11 5.5C11 6.26083 10.8556 6.97583 10.5669 7.645C10.2781 8.31417 9.88625 8.89625 9.39125 9.39125C8.89625 9.88625 8.31417 10.2781 7.645 10.5669C6.97583 10.8556 6.26083 11 5.5 11ZM5.5 9.9C6.72833 9.9 7.76875 9.47375 8.62125 8.62125C9.47375 7.76875 9.9 6.72833 9.9 5.5C9.9 4.27167 9.47375 3.23125 8.62125 2.37875C7.76875 1.52625 6.72833 1.1 5.5 1.1C4.27167 1.1 3.23125 1.52625 2.37875 2.37875C1.52625 3.23125 1.1 4.27167 1.1 5.5C1.1 6.72833 1.52625 7.76875 2.37875 8.62125C3.23125 9.47375 4.27167 9.9 5.5 9.9Z",
    fill: "#3AA65C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.77f3b234427f415d84b5c799dd707c2b.svg";
export { ForwardRef as ReactComponent };